import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class EditEntityUrl extends React.Component {

    constructor(props) {
        super(props);

        this.state = {url: this.props.entityUrl ? this.props.entityUrl : ''};

        this.changeUrl = this.changeUrl.bind(this);
        this.blurAction = this.blurAction.bind(this);
    }

    changeUrl(event) {
        let userInput = event.target.value;
        this.setState({url: userInput});
    }

    blurAction() {
        let userInput = this.state.url;
        userInput = userInput.trim();
        userInput = userInput.replace(/^(https?:|)\/\//,'');

        this.setState({url: userInput});

        if (this.props.entityUrl !== userInput) {
            this.props.onBlur("entityUrl", userInput);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.entityUrl !== this.props.entityUrl) {
            this.setState({url: nextProps.entityUrl ? nextProps.entityUrl : ''})
        }
    }


    render() {
        return (
            <div className="edit-third-party__about__input-group">
                <div className="row-label">
                    <label className="row-label" htmlFor="edit-third-party__about__company-url">
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.urlLabel" />
                    </label>
                </div>
                <input type="text"
                       id="edit-third-party__about__company-url"
                       name="entityUrl"
                       value={this.state.url}
                       onChange={this.changeUrl}
                       onBlur={this.blurAction} />
                <div className="edit-third-party__about__url-tip"><FormattedMessage id="Entities_Edit_UIText_editThirdParty.urlTip" /></div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditEntityUrl.jsx